angular.module(NgAppName).component('crCalculator', {
	templateUrl: 'crCalculator.html',
	transclude: true,
	bindings: {
		isMobile: '<',
		askingPrice: '<',
		commonCharges: '<',
		tax: '<',
		monthlyMortgage: '<',
		downpaymentAmount: '<',
		downpaymentPercentage: '<',
		mortgageTerm: '<',
		interestRate: '<',
		buildingTypeId: '<'
	},
	controller: ['$timeout', 'PubSub', '$element', 'crResourcesService', 'StateService', function($timeout, PubSub, $element, crResourcesService, StateService) {
		let ctrl = this;
		this.pageID = angular.element(document.body).attr('id');
		this.chartContainer = angular.element($element[0].querySelector('.chart-container'));
		this.o_interestRate = this.interestRate;
		this.o_downpaymentPercentage = this.downpaymentPercentage;
		this.o_mortgageTerm = this.mortgageTerm;
		this.downpaymentAmount = ((this.askingPrice / 100) * this.downpaymentPercentage).round();
		this.mortgageAmount = (this.askingPrice - this.downpaymentAmount).round();

		this.calculate = function(e, changedField) {
			if (e) {
				e.preventDefault();
			}

			if (changedField === 'interestRate' && this.interestRate < 0) {
				this.interestRate = 0;
			} else if (changedField === 'mortgageTerm' && this.mortgageTerm < 5) {
				this.mortgageTerm = 5;
			} else if (changedField === 'downpaymentPercentage') {
				if (this.downpaymentPercentage < 1) {
					this.downpaymentPercentage = 1;
				} else if (this.downpaymentPercentage > 100) {
					this.downpaymentPercentage = 100;
				}

				this.downpaymentAmount = ((this.askingPrice / 100) * this.downpaymentPercentage).round();
				this.mortgageAmount = (this.askingPrice - this.downpaymentAmount).round().toString();

			} else if (changedField === 'mortgageAmount') {
				if (this.askingPrice > 0 && this.mortgageAmount > this.askingPrice) {
					this.mortgageAmount = this.askingPrice;
				} else if (this.mortgageAmount < 1) {
					this.mortgageAmount = 0;
				}

				this.downpaymentAmount = (this.askingPrice - this.mortgageAmount).round();
				this.downpaymentPercentage= ((this.downpaymentAmount * 100) / this.askingPrice);

			} else if (changedField === 'downpaymentAmount') {
				if (this.downpaymentAmount < (this.askingPrice * (1 / 100))) {
					this.downpaymentAmount = this.askingPrice * (1 / 100);
				}else if (this.downpaymentAmount > this.askingPrice) {
					this.downpaymentAmount = this.askingPrice;
				}

				this.mortgageAmount = (this.askingPrice - this.downpaymentAmount).round().toString();
				this.downpaymentPercentage= ((this.downpaymentAmount * 100) / this.askingPrice).round(1);
			} else {
				if (!this.interestRate) {
					this.interestRate = 0;
				}

				// calculate the total and update the chart
				let principle = parseInt(this.mortgageAmount);

				let	interest	= this.interestRate;
				let interest_rate = (interest/100) / 12;
				let months = this.mortgageTerm * 12;
				let m_mortgage = ((Math.floor((principle * interest_rate) / (1-Math.pow(1 + interest_rate, (-1 * months))) * 100) / 100).toFixed(0));

				this.monthlyMortgage = (m_mortgage.toFloat() < 1)? (m_mortgage.toFloat()).round(1) : (m_mortgage.toFloat()).round();
				this.totalMonthlyCost = this.monthlyMortgage + this.commonCharges + this.tax;

				this.updateChart();
			}

			PubSub.publish('cr-calculator-recalculate', {
				'monthlyMortgage': this.monthlyMortgage,
				'percDownpayment': this.downpaymentPercentage,
				'downpayment': this.downpaymentAmount
			});
		};

		this.updateChart = function() {
			this.chart.series[0].setData(ctrl.getTotalMonthlyData());
			this.chart.series[1].setData(ctrl.getChartData());
			this.chart.redraw();
		};

		this.getTotalMonthlyData = function() {
			return [{
				name: 'Total Monthly Cost*',
				y: this.totalMonthlyCost,
				color: '#ffffff'
			}];
		};

		this.getChartData = function() {
			let data = [];

			if (this.commonCharges > 100) {
				let label = '';

				if (this.buildingTypeId === 2) {
					label = 'Common Charges';
				} else if (this.buildingTypeId === 3 || this.buildingTypeId === 7) {
					label = 'Maintenance';
				} else {
					label = 'Maintenance / CC';
				}

				data.push({
					name: label,
					y: this.commonCharges,
					color: '#00B5C4'
				});
			}

			if (this.tax > 100) {
				data.push({
					name: 'Real Estate Tax',
					y: this.tax,
					color: '#008c99'
				});
			}

			data.push({
				name: 'Est. Mortgage',
				y: this.monthlyMortgage,
				color: '#ff6a00'
			});

			return data;
		};

		this.createChart = function() {
			Highcharts.setOptions({
				lang: {
					thousandsSep: ','
				}
			});

			// Create the chart
			this.chart = new Highcharts.chart(this.chartContainer[0], {
				chart: {
					type: 'pie',
					spacingTop: 0,
					height: 250,
					marginRight: 135,
					width: 400
				},
				title: {
					text: ''
				},
				credits: {
					enabled: false
				},
				tooltip: {
					backgroundColor: 'transparent',
					useHTML: true,
					borderWidth: 0,
					shadow: false,
					style: {
						padding: 0
					},
					formatter: function(){
						var html = '';
						html += '<div class="tooltip_content" > <span style="color:' + (this.color.indexOf('#fff') === -1 ? this.color : '#000') + ';">$' + Highcharts.numberFormat(this.y, 0) + '</span><br>' + this.key + '</div>';
						return html;
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							connectorWidth: 0
						},
						tooltip:{
							padding: 0
						},
						showInLegend: true
					}
				},
				series: [{
					name: '',
					data: ctrl.getTotalMonthlyData(),
					size: '80%',
					showInLegend: false,
					dataLabels: {
						enabled: true,
						inside: true,
						useHTML: true,
						formatter: function () {
							let addClass = '';
							let value = Highcharts.numberFormat(this.y, 0);

							if (value.length >= 7){
								addClass = '_medium';
							} else if (value.length >= 9){
								addClass = '_small';
							}

							let html = '<div class="total"><b class=' + addClass + '>$'+ value + '</b><br />' + this.point.name + '</div>';
							return html;
						},
						color: '#000',
						style:{
							fontSize: '13px'
						},
						y: -140,
						x: -80
					}
				}, {
					data: ctrl.getChartData(),
					size: '100%',
					innerSize: '80%',
					dataLabels: {
						enabled: false
					}
				}],
				legend: {
					align: 'right',
					verticalAlign: 'top',
					layout: 'vertical',
					x: 15,
					y: 25,
					itemMarginBottom: 25,
					useHTML: true,
					symbolHeight: 0,
					symbolWidth: 0,
					symbolRadius: 0,
					squareSymbol: false,
					itemStyle:{
						fontSize: '13px',
					},
					labelFormatter: function() {
						let html = '';
						html += '<div class="value" style="color:' + this.color + ';">$' + Highcharts.numberFormat(this.y, 0) + '</div>' + this.name;
						return html;
					}
				}
			});
		};

		this.reset = function(e) {
			if (e) {
				e.preventDefault();
			}

			this.interestRate = this.o_interestRate;
			this.downpaymentPercentage = this.o_downpaymentPercentage;
			this.mortgageTerm = this.o_mortgageTerm;

			this.downpaymentAmount = ((this.askingPrice / 100) * this.downpaymentPercentage).round();
			this.mortgageAmount = (this.askingPrice - this.downpaymentAmount).round();

			this.calculate();
			this.saveData();
		};

		this.calcAndSave = (e, changedField) => {
			this.calculate(e, changedField);
			this.saveData();
		};

		this.saveData = function() {
			let storage = {};
			storage.downpaymentAmount = this.downpaymentAmount;
			storage.mortgageAmount = this.mortgageAmount;

			storage.downpaymentPercentage = this.downpaymentPercentage;
			storage.mortgageTerm = this.mortgageTerm;
			storage.interestRate = this.interestRate;

			StateService.saveKey(this.pageID, 'calculatorData', JSON.stringify(storage));
		};

		this.applySavedData = function() {
			let pageCookieData = StateService.get(this.pageID);

			if (pageCookieData && pageCookieData.calculatorData) {
				let data = JSON.parse(pageCookieData.calculatorData);

				this.downpaymentAmount = parseInt(data.downpaymentAmount);
				this.mortgageAmount = parseInt(data.mortgageAmount);
				this.downpaymentPercentage = parseInt(data.downpaymentPercentage);
				this.mortgageTerm = parseInt(data.mortgageTerm);
				this.interestRate = parseFloat(data.interestRate);
			}
		};


		this.createChart();

		// apply the saved data of the calculator (mortgageTerm, interestRate and downpaymentPercentage)
		this.applySavedData();

		this.calculate();
	}]
});
